var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    stroke: "#5F8FC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69971 12.4232C7.59551 12.5196 7.4479 12.6 7.31766 12.6C7.18741 12.6 7.0398 12.5156 6.93126 12.4192L4.5 10.1692L5.27279 9.45402L7.322 11.3504L12.7402 6.3L13.5 7.02723L7.69971 12.4232Z",
    fill: "#5F8FC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.63c17ab40eeab38aac6480d4add9e30c.svg";
export { ForwardRef as ReactComponent };